import { render, staticRenderFns } from "./Registary.vue?vue&type=template&id=3810badc&"
import script from "./Registary.vue?vue&type=script&lang=ts&"
export * from "./Registary.vue?vue&type=script&lang=ts&"
import style0 from "./Registary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Registary.vue"
export default component.exports